import { getConfig } from 'config/config';

const { config } = getConfig();
export type langTypes =
  | 'GER'
  | 'ENG'
  | 'FRA'
  | 'HNG'
  | 'ITA'
  | 'JAP'
  | 'SP'
  | 'KOR'
  | 'CIN'
  | 'POL'
  | 'RUS'
  | 'NLD'
  | 'NOR';

export const AppName = config.APP_FULL_NAME || 'Connact App';
export const PostsName = config.POSTS_NAME || 'Neuigkeiten';

export const passwordDigits = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'gew':
    case 'atlasinitiative':
    case 'web':
      return {
        GER: '12',
        ENG: '12',
        FRA: '12',
        HNG: '12',
        ITA: '12',
        JAP: '12',
        SP: '12',
        KOR: '12',
        CIN: '12',
        POL: '12',
        RUS: '12',
        NLD: '12',
        NOR: '12',
      }[lang];
    default:
      return {
        GER: 'acht',
        ENG: 'eight',
        FRA: 'huit',
        HNG: 'nyolc',
        ITA: 'otto',
        JAP: 'エイト',
        SP: 'ocho',
        KOR: '여덟',
        CIN: '八',
        POL: 'osiem',
        RUS: 'Восемь',
        NLD: 'acht',
        NOR: 'åtte',
      }[lang];
  }
};

export const acceptEventName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'bvs':
    case 'landfrauen':
    case 'bdyoga':
      return {
        GER: { accept: 'Interessiert', cancel: 'Nicht interessiert' },
        ENG: { accept: 'Interested', cancel: 'Not interested' },
        ITA: { accept: 'Interessato', cancel: 'Non interessato' },
        FRA: { accept: 'Intéressé', cancel: 'Pas intéressé' },
        HNG: { accept: 'Érdeklődik', cancel: 'Nem érdekel' },
        JAP: { accept: '興味あり', cancel: '興味なし' },
        SP: { accept: 'Interesados', cancel: 'No me interesa' },
        KOR: { accept: '관심', cancel: '관심 없음' },
        CIN: { accept: '感兴趣', cancel: '不感兴趣' },
        POL: { accept: 'Zainteresowany', cancel: 'Nie jestem zainteresowany' },
        RUS: { accept: 'Интересует', cancel: 'Неинтересно' },
        NLD: { accept: 'Geïnteresseerd', cancel: 'Niet geïnteresseerd' },
        NOR: { accept: 'Interessert', cancel: 'Ikke interessert' },
      }[lang];
    default:
      return {
        GER: { accept: 'Zusagen', cancel: 'Absagen' },
        ENG: { accept: 'Accept', cancel: 'Cancel' },
        ITA: { accept: 'Impegni', cancel: 'Cancellazioni' },
        FRA: { accept: 'Engagements', cancel: 'Annulations' },
        HNG: { accept: 'Kötelezettségvállalások', cancel: 'Lemondások' },
        JAP: { accept: 'コミットメント', cancel: 'アブサゲン' },
        SP: { accept: 'Compromisos', cancel: 'Anulaciones' },
        KOR: { accept: '약속', cancel: '취소' },
        CIN: { accept: '承诺', cancel: '取消预订' },
        POL: { accept: 'Zobowiązania', cancel: 'Anulowanie' },
        RUS: { accept: 'Принять', cancel: 'Отмена' },
        NLD: { accept: 'Accepteren', cancel: 'Annuleren' },
        NOR: { accept: 'Akseptere', cancel: 'Kansellere' },
      }[lang];
  }
};

export const AcceptEventName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    default:
      return {
        GER: { accept: 'Interessiert', cancel: 'Nicht interessiert' },
        ENG: { accept: 'Interested', cancel: 'Not interested' },
        ITA: { accept: 'Interessato', cancel: 'Non interessato' },
        FRA: { accept: 'Intéressé', cancel: 'Pas intéressé' },
        HNG: { accept: 'Érdeklődik', cancel: 'Nem érdekel' },
        JAP: { accept: '興味あり', cancel: '興味なし' },
        SP: { accept: 'Interesados', cancel: 'No me interesa' },
        KOR: { accept: '관심', cancel: '관심 없음' },
        CIN: { accept: '感兴趣', cancel: '不感兴趣' },
        POL: { accept: 'Zainteresowany', cancel: 'Nie jestem zainteresowany' },
        RUS: { accept: 'Интересует', cancel: 'Неинтересно' },
        NLD: { accept: 'Geïnteresseerd', cancel: 'Niet geïnteresseerd' },
        NOR: { accept: 'Interessert', cancel: 'Ikke interessert' },
      }[lang];
  }
};

export const SignUpCorpsName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    default:
      return {
        GER: 'Mitgliedschaft',
        ENG: 'Membership',
        FRA: 'Adhésion',
        HNG: 'Tagság',
        ITA: 'Soci',
        JAP: 'メンバーシップ',
        SP: 'Afiliación',
        KOR: '멤버십',
        CIN: '会员资格',
        POL: 'Członkostwo',
        RUS: 'Членство',
        NLD: 'Lidmaatschap',
        NOR: 'Medlemskap',
      }[lang];
  }
};

export const SignUpCorpsNameGuest = (lang: langTypes) => {
  switch (config.APP_NAME) {
    default:
      return {
        GER: 'Interessiert an',
        ENG: 'Interested in',
        FRA: 'Intéressé par',
        HNG: 'Érdekel',
        ITA: 'Interessato a',
        JAP: '興味がある',
        SP: 'Interesado en',
        KOR: '관심 분야',
        CIN: '感兴趣',
        POL: 'Zainteresowany',
        RUS: 'Заинтересованные в',
        NLD: 'Geïnteresseerd in',
        NOR: 'Interessert i',
      }[lang];
  }
};

export const KreiseName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'vid':
      return {
        GER: {
          multi: 'Chats für Vorträge & mehr',
          single: 'Chat für Vorträge & mehr',
          singleArticle: 'diesen Chat für Vorträge & mehr',
        },
        ENG: { multi: 'Group chats', single: 'Group chat' },
        FRA: { multi: 'Chats de groupe', single: 'Chat de groupe' },
        HNG: { multi: 'Csoportos beszélgetések', single: 'Csoportos csevegés' },
        ITA: { multi: 'Chat di gruppo', single: 'Chat di gruppo' },
        JAP: { multi: 'グループチャット', single: 'グループチャット', singleArticle: 'このグループチャット' },
        SP: { multi: 'Chats de grupo', single: 'Chat en grupo', singleArticle: 'este chat de grupo' },
        KOR: { multi: '그룹 채팅', single: '그룹 채팅', singleArticle: '이 그룹 채팅' },
        CIN: { multi: '群组聊天', single: '群组聊天', singleArticle: '这个群聊' },
        POL: { multi: 'Czaty grupowe', single: 'Czat grupowy', singleArticle: 'ten czat grupowy' },
        RUS: { multi: 'Групповые чаты', single: 'Групповой чат', singleArticle: 'этот групповой чат' },
        NLD: { multi: 'Groepschats', single: 'Groepschats' },
        NOR: { multi: 'Gruppesamtaler', single: 'Gruppesamtale' },
      }[lang];
    case 'meinp3':
    case 'werteunion':
      return {
        GER: { multi: 'Gruppen', single: 'Gruppe', singleArticle: 'diese Gruppe' },
        ENG: { multi: 'Groups', single: 'Group' },
        FRA: { multi: 'Groupes', single: 'Groupe' },
        HNG: { multi: 'Csoportok', single: 'Csoport' },
        ITA: { multi: 'Gruppi', single: 'Gruppo' },
        JAP: { multi: 'グループ', single: '団体', singleArticle: 'このグループ' },
        SP: { multi: 'Grupos', single: 'Grupo', singleArticle: 'este grupo' },
        KOR: { multi: '그룹', single: '그룹', singleArticle: '이 그룹' },
        CIN: { multi: '组别', single: '组别', singleArticle: '该组' },
        POL: { multi: 'Grupy', single: 'Grupa', singleArticle: 'ta grupa' },
        RUS: { multi: 'Группы', single: 'Группа', singleArticle: 'эта группа' },
        NLD: { multi: 'Groepen', single: 'Groep' },
        NOR: { multi: 'Grupper', single: 'Gruppe' },
      }[lang];
    case 'aps':
      return {
        GER: { multi: 'Gruppenchats und AGs', single: 'Gruppenchat und AG', singleArticle: 'diesen Gruppenchat' },
        ENG: { multi: 'Groups', single: 'Group' },
        FRA: { multi: 'Groupes', single: 'Groupe' },
        HNG: { multi: 'Csoportok', single: 'Csoport' },
        ITA: { multi: 'Gruppi', single: 'Gruppo' },
        JAP: { multi: 'グループチャットとAG', single: 'グループチャットとAG', singleArticle: 'このグループチャット' },
        SP: { multi: 'Chats de grupo y AG', single: 'Chat en grupo y AG', singleArticle: 'este chat de grupo' },
        KOR: { multi: '그룹 채팅 및 AG', single: '그룹 채팅 및 AG', singleArticle: '이 그룹 채팅' },
        CIN: { multi: '群聊和 AG', single: '群聊和 AG', singleArticle: '这个群聊' },
        POL: { multi: 'Czaty grupowe i AG', single: 'Czat grupowy i AG', singleArticle: 'ten czat grupowy' },
        RUS: { multi: 'Групповые чаты и AG', single: 'Групповой чат и AG', singleArticle: 'этот групповой чат' },
        NLD: { multi: 'Groepen', single: 'Groep' },
        NOR: { multi: 'Grupper', single: 'Gruppe' },
      }[lang];
    default:
      return {
        GER: { multi: 'Gruppenchats', single: 'Gruppenchat', singleArticle: 'diesen Gruppenchat' },
        ENG: { multi: 'Group chats', single: 'Group chat' },
        FRA: { multi: 'Chats de groupe', single: 'Chat de groupe' },
        HNG: { multi: 'Csoportos beszélgetések', single: 'Csoportos csevegés' },
        ITA: { multi: 'Chat di gruppo', single: 'Chat di gruppo' },
        JAP: { multi: 'グループチャット', single: 'グループチャット', singleArticle: 'このグループチャット' },
        SP: { multi: 'Chats de grupo', single: 'Chat en grupo', singleArticle: 'este chat de grupo' },
        KOR: { multi: '그룹 채팅', single: '그룹 채팅', singleArticle: '이 그룹 채팅' },
        CIN: { multi: '群组聊天', single: '群组聊天', singleArticle: '这个群聊' },
        POL: { multi: 'Czaty grupowe', single: 'Czat grupowy', singleArticle: 'ten czat grupowy' },
        RUS: { multi: 'Групповые чаты', single: 'Групповой чат', singleArticle: 'этот групповой чат' },
        NLD: { multi: 'Groepschats', single: 'Groepschats' },
        NOR: { multi: 'Gruppesamtaler', single: 'Gruppesamtale' },
      }[lang];
  }
};

export const StudyName = (lang: langTypes) => {
  let defaultNames = {
    GER: {
      hochsule: 'Ausbildung-/Hochschule',
      studiengang: 'Ausbildung-/Studiengang',
      abshchluss: 'Abschluss',
      short: 'Ausbildung',
      university: 'Hochschule',
    },
    ENG: {
      hochsule: 'Education-/Higher education',
      studiengang: 'Education-/Study program',
      abshchluss: 'Conclusion',
      short: 'Education',
      university: 'Higher education',
    },
    FRA: {
      hochsule: 'Formation-/École supérieure',
      studiengang: "Formation-/Filière d'études",
      abshchluss: 'Conclusion',
      short: 'Formation',
      university: 'École supérieure',
    },
    HNG: {
      hochsule: 'Képzés-/Gimnázium',
      studiengang: 'Képzés-/Tanulmányi program',
      abshchluss: 'Zárás',
      short: 'Képzés',
      university: 'Gimnázium',
    },
    ITA: {
      hochsule: 'Formazione-/Scuola superiore',
      studiengang: 'Formazione-/Programma di studio',
      abshchluss: 'Chiusura',
      short: 'Formazione',
      university: 'Scuola superiore',
    },
    JAP: {
      hochsule: 'トレーニング/大学',
      studiengang: '研修/学習プログラム',
      abshchluss: '結論',
      short: '教育',
      university: '大学',
    },
    SP: {
      hochsule: 'Formación/universidad',
      studiengang: 'Programa de formación/estudio',
      abshchluss: 'Conclusión',
      short: 'Educación',
      university: 'Universidad',
    },
    KOR: {
      hochsule: '교육/대학',
      studiengang: '교육/학습 프로그램',
      abshchluss: '결론',
      short: '교육',
      university: '대학',
    },
    CIN: {
      hochsule: '培训/大学',
      studiengang: '培训/学习计划',
      abshchluss: '结论',
      short: '教育',
      university: '大学',
    },
    POL: {
      hochsule: 'Szkolenie/uniwersytet',
      studiengang: 'Program szkoleniowy/studyjny',
      abshchluss: 'Wnioski',
      short: 'Edukacja',
      university: 'Uniwersytet',
    },
    RUS: {
      hochsule: 'Обучение/университет',
      studiengang: 'Программа подготовки/обучения',
      abshchluss: 'Заключение',
      short: 'Образование',
      university: 'Университет',
    },
    NLD: {
      hochsule: 'Onderwijs/Hoger onderwijs',
      studiengang: 'Onderwijs-/Studieprogramma',
      abshchluss: 'Conclusie',
      short: 'Onderwijs',
      university: 'Hoger onderwijs',
    },
    NOR: {
      hochsule: 'Utdanning / Høyere utdanning',
      studiengang: 'Utdanning / Studieprogram',
      abshchluss: 'Konklusjon',
      short: 'Utdanning',
      university: 'Høyere utdanning',
    },
  };
  switch (config.APP_NAME) {
    case 'meinp3':
      defaultNames.GER.studiengang = 'Aus-/Weiterbildung';
      defaultNames.ENG.studiengang = 'Education-/Training';
      defaultNames.FRA.studiengang = 'Formation initiale-/Continue';
      defaultNames.HNG.studiengang = 'Oktatás/-Képzés';
      defaultNames.ITA.studiengang = 'Istruzione-/Formazione';
      defaultNames.JAP.studiengang = 'トレーニング/進学';
      defaultNames.SP.studiengang = 'Formación';
      defaultNames.KOR.studiengang = '교육/추가 교육';
      defaultNames.CIN.studiengang = '培训/继续教育';
      defaultNames.POL.studiengang = 'Szkolenie/dalsza edukacja';
      defaultNames.RUS.studiengang = 'Обучение/повышение квалификации';
      defaultNames.NLD.studiengang = 'Onderwijs/Training';
      defaultNames.NOR.studiengang = 'Utdanning / Opplæring';
      return defaultNames[lang];
    case 'wilkar':
      defaultNames.GER.hochsule = 'Fremdsprachen';
      defaultNames.GER.university = 'Fremdsprachen';
      defaultNames.GER.studiengang = 'Aus-/Weiterbildung';

      defaultNames.ENG.hochsule = 'Foreign languages';
      defaultNames.ENG.university = 'Foreign languages';
      defaultNames.ENG.studiengang = 'Training/further training';

      defaultNames.ITA.hochsule = 'Lingue straniere';
      defaultNames.ITA.university = 'Lingue straniere';
      defaultNames.ITA.studiengang = 'Formazione/istruzione continua';

      defaultNames.FRA.hochsule = 'Langues étrangères';
      defaultNames.FRA.university = 'Langues étrangères';
      defaultNames.FRA.studiengang = 'Formation initiale/continue';

      defaultNames.HNG.hochsule = 'Idegen nyelvek';
      defaultNames.HNG.university = 'Idegen nyelvek';
      defaultNames.HNG.studiengang = 'Képzés/továbbképzés';

      defaultNames.JAP.hochsule = '外国語';
      defaultNames.JAP.university = '外国語';
      defaultNames.JAP.studiengang = 'トレーニング/進学';

      defaultNames.SP.hochsule = 'Idiomas extranjeros';
      defaultNames.SP.university = 'Idiomas extranjeros';
      defaultNames.SP.studiengang = 'Formación';

      defaultNames.KOR.hochsule = '외국어';
      defaultNames.KOR.university = '외국어';
      defaultNames.KOR.studiengang = '교육/추가 교육';

      defaultNames.CIN.hochsule = '外语';
      defaultNames.CIN.university = '外语';
      defaultNames.CIN.studiengang = '培训/继续教育';

      defaultNames.POL.hochsule = 'Języki obce';
      defaultNames.POL.university = 'Języki obce';
      defaultNames.POL.studiengang = 'Szkolenie/dalsza edukacja';

      defaultNames.RUS.hochsule = 'Иностранные языки';
      defaultNames.RUS.university = 'Иностранные языки';
      defaultNames.RUS.studiengang = 'Обучение/повышение квалификации';

      defaultNames.NLD.hochsule = 'Vreemde talen';
      defaultNames.NLD.university = 'Vreemde talen';
      defaultNames.NLD.studiengang = 'Opleiding/bijscholing';

      defaultNames.NOR.hochsule = 'Fremmedspråk';
      defaultNames.NOR.university = 'Fremmedspråk';
      defaultNames.NOR.studiengang = 'Opplæring / Videreutdanning';
      return defaultNames[lang];
    default:
      return defaultNames[lang];
  }
};

export const FunctionName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'cbs':
      return {
        GER: 'Funktion/Stimmlage',
        ENG: 'Function/Vocal range',
        FRA: 'Fonction/Tessiture',
        HNG: 'Funkció/Hangterjedelem',
        ITA: 'Funzione/Estensione vocale',
        JAP: '機能/声域',
        SP: 'Función/Rango vocal',
        KOR: '기능/음역',
        CIN: '功能/音域',
        POL: 'Funkcja/Zakres głosu',
        RUS: 'Функция/Вокальный диапазон',
        NLD: 'Functie/Vocale bereik',
        NOR: 'Funksjon / Stemmepositur',
      }[lang];
    case 'meinp3':
      return {
        GER: 'Bereich',
        ENG: 'Area',
        FRA: 'Domaine',
        HNG: 'Terület',
        ITA: 'Area',
        JAP: 'レンジ',
        SP: 'Gama',
        KOR: '범위',
        CIN: '范围',
        POL: 'Zasięg',
        RUS: 'Диапазон',
        NLD: 'Gebied',
        NOR: 'Område',
      }[lang];
    case 'bvs':
      return {
        GER: 'Bestellungstenor',
        ENG: 'Scope',
        FRA: 'Scope',
        HNG: 'Scope',
        ITA: 'Scope',
        JAP: 'オーダーテナー',
        SP: 'Pedir tenor',
        KOR: '테너 주문',
        CIN: '订购男高音',
        POL: 'Zamów tenor',
        RUS: 'Заказать тенор',
        NLD: 'Toepassingsgebied',
        NOR: 'Omfang',
      }[lang];
    case 'sherides':
      return {
        GER: 'Fahrstil',
        ENG: 'Fahrstil',
        FRA: 'Fahrstil',
        HNG: 'Fahrstil',
        ITA: 'Fahrstil',
        JAP: 'Fahrstil',
        SP: 'Fahrstil',
        KOR: 'Fahrstil',
        CIN: 'Fahrstil',
        POL: 'Fahrstil',
        RUS: 'Fahrstil',
        NLD: 'Fahrstil',
        NOR: 'Kjørestil',
      }[lang];
    default:
      return {
        GER: 'Funktion',
        ENG: 'Function',
        FRA: 'Fonction',
        HNG: 'Funkció',
        ITA: 'Funzione',
        JAP: '機能',
        SP: 'Función',
        KOR: '기능',
        CIN: '功能',
        POL: 'Funkcja',
        RUS: 'Функция',
        NLD: 'Functie',
        NOR: 'Funksjon',
      }[lang];
  }
};

export const DocumentsName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'gew':
      return {
        GER: 'Dateien',
        ENG: 'Documents',
        FRA: 'Documents',
        HNG: 'Dokumentumok',
        ITA: 'Documenti',
        JAP: '書類',
        SP: 'Documentos',
        KOR: '문서',
        CIN: '文件',
        POL: 'Dokumenty',
        RUS: 'Документы',
        NLD: 'Documenten',
        NOR: 'Dokumenter',
      }[lang];
    case 'vid':
      return {
        GER: 'Tagungsunterlagen & Dokumente',
        ENG: 'Documents',
        FRA: 'Documents',
        HNG: 'Dokumentumok',
        ITA: 'Documenti',
        JAP: '書類',
        SP: 'Documentos',
        KOR: '문서',
        CIN: '文件',
        POL: 'Dokumenty',
        RUS: 'Документы',
        NLD: 'Documenten',
        NOR: 'Dokumenter',
      }[lang];
    case 'djv':
      return {
        GER: 'Blickpunkt & Dokumente',
        ENG: 'Blickpunkt & Dokumente',
        FRA: 'Blickpunkt & Dokumente',
        HNG: 'Blickpunkt & Dokumente',
        ITA: 'Blickpunkt & Dokumente',
        JAP: 'Blickpunkt & Dokumente',
        SP: 'Blickpunkt & Dokumente',
        KOR: 'Blickpunkt & Dokumente',
        CIN: 'Blickpunkt & Dokumente',
        POL: 'Blickpunkt & Dokumente',
        RUS: 'Blickpunkt & Dokumente',
        NLD: 'Blickpunkt & Dokumente',
        NOR: 'Blickpunkt & Dokumente',
      }[lang];
    case 'meinp3':
      return {
        GER: 'Downloads',
        ENG: 'Downloads',
        FRA: 'Téléchargements',
        HNG: 'Letöltések',
        ITA: 'Scaricamento',
        JAP: 'ダウンロード',
        SP: 'Descargas',
        KOR: '다운로드',
        CIN: '下载',
        POL: 'Pliki do pobrania',
        RUS: 'Загрузки',
        NLD: 'Downloads',
        NOR: 'Nedlastinger',
      }[lang];
    case 'aps':
      return {
        GER: 'Dokumente & Projekte',
        ENG: 'Documents & Projects',
        FRA: 'Documents et projets',
        HNG: 'Dokumentumok és projektek',
        ITA: 'Documenti e progetti',
        JAP: 'ドキュメント＆プロジェクト',
        SP: 'Documentos y proyectos',
        KOR: '문서 및 프로젝트',
        CIN: '文件与项目',
        POL: 'Dokumenty i projekty',
        RUS: 'Документы и проекты',
        NLD: 'Documenten en projecten',
        NOR: 'Documents & Projects',
      }[lang];
    case 'gdl':
      return {
        GER: 'VORAUS & Dokumente',
        ENG: 'VORAUS & Documents',
        FRA: 'VORAUS & Documents',
        HNG: 'VORAUS & Dokumentumok',
        ITA: 'VORAUS & Documenti',
        JAP: '書類',
        SP: 'Documentos',
        KOR: '문서',
        CIN: '文件',
        POL: 'Dokumenty',
        RUS: 'Документы',
        NLD: 'Documenten',
        NOR: 'Documents',
      }[lang];
    default:
      return {
        GER: 'Dokumente',
        ENG: 'Documents',
        FRA: 'Documents',
        HNG: 'Dokumentumok',
        ITA: 'Documenti',
        JAP: '書類',
        SP: 'Documentos',
        KOR: '문서',
        CIN: '文件',
        POL: 'Dokumenty',
        RUS: 'Документы',
        NLD: 'Documenten',
        NOR: 'Dokumenter',
      }[lang];
  }
};

export const CorpsEditDate = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'meinp3':
      return {
        GER: 'Bei P3 seit',
        ENG: 'At P3 since',
        FRA: 'À P3 puisque',
        HNG: 'A P3-nál',
        ITA: 'In P3 da quando',
        JAP: 'P3以来',
        SP: 'En P3 desde',
        KOR: '이후 P3에서',
        CIN: '在 P3，因为',
        POL: 'W P3 od',
        RUS: 'В P3 с',
        NLD: 'Bij P3 sinds',
        NOR: 'Hos P3 siden',
      }[lang];
    default:
      return {
        GER: 'Datum des Beitritts',
        ENG: 'Date of joining',
        FRA: "Date d'adhésion",
        HNG: 'A csatlakozás időpontja',
        ITA: 'Data di adesione',
        JAP: '加盟日',
        SP: 'Fecha de adhesión',
        KOR: '가입 날짜',
        CIN: '加入日期',
        POL: 'Data przystąpienia',
        RUS: 'Дата вступления',
        NLD: 'Datum indiensttreding',
        NOR: 'Inntreden dato',
      }[lang];
  }
};

export const CalendarName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'meinp3':
      return {
        GER: 'Termine & Geburtstage',
        ENG: 'Dates & Birthdays',
        FRA: 'Dates & anniversaires',
        HNG: 'Dátumok és születésnapok',
        ITA: 'Date e compleanni',
        JAP: '日付と誕生日',
        SP: 'Fechas y cumpleaños',
        KOR: '날짜 및 생일',
        CIN: '日期和生日',
        POL: 'Daty i urodziny',
        RUS: 'Даты и дни рождения',
        NLD: 'Data en verjaardagen',
        NOR: 'Datoer og bursdager',
      }[lang];
    case 'aps':
      return {
        GER: 'Terminkalender',
        ENG: 'Appointment calendar',
        FRA: 'Agenda',
        HNG: 'Napló',
        ITA: 'Diario',
        JAP: '予約カレンダー',
        SP: 'Calendario de citas',
        KOR: '약속 캘린더',
        CIN: '预约日历',
        POL: 'Kalendarz spotkań',
        RUS: 'Календарь назначений',
        NLD: 'Afsprakenkalender',
        NOR: 'Avtalekalender',
      }[lang];
    case 'hcn':
      return {
        GER: 'Termine',
        ENG: 'Events',
        FRA: 'Événements',
        HNG: 'Események',
        ITA: 'Eventi',
        JAP: 'イベント',
        SP: 'Eventos',
        KOR: '이벤트',
        CIN: '活动',
        POL: 'Wydarzenia',
        RUS: 'Cобытия',
        NLD: 'Evenementen',
        NOR: 'Hendelser',
      }[lang];

    default:
      return {
        GER: 'Veranstaltungen',
        ENG: 'Events',
        FRA: 'Événements',
        HNG: 'Események',
        ITA: 'Eventi',
        JAP: 'イベント',
        SP: 'Eventos',
        KOR: '이벤트',
        CIN: '活动',
        POL: 'Wydarzenia',
        RUS: 'Cобытия',
        NLD: 'Evenementen',
        NOR: 'Arrangementer',
      }[lang];
  }
};

export const MessagesName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'aps':
      return {
        GER: 'Privatnachrichten',
        ENG: 'Private messages',
        ITA: 'Messaggi privati',
        FRA: 'Messages privé',
        HNG: 'Privát üzenetek',
        JAP: 'プライベートメッセージ',
        SP: 'Mensajes privados',
        KOR: '비공개 메시지',
        CIN: '私人信息',
        POL: 'Prywatne wiadomości',
        RUS: 'Личные сообщения',
        NLD: 'Privéberichten',
        NOR: 'Private meldinger',
      }[lang];
    default:
      return {
        GER: 'Private Nachrichten',
        ENG: 'Private Messages',
        ITA: 'Messaggi',
        FRA: 'Messages',
        HNG: 'Üzenetek',
        JAP: 'ニュース',
        SP: 'Noticias',
        KOR: '뉴스',
        CIN: '新闻',
        POL: 'Aktualności',
        RUS: 'Сообщения',
        NLD: 'Privéberichten',
        NOR: 'Private meldinger',
      }[lang];
  }
};

export const ProfileName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'aps':
      return {
        GER: 'Mein Profil',
        ENG: 'My profile',
        ITA: 'Il mio profilo',
        FRA: 'Mon Profil',
        HNG: 'Profilom',
        JAP: 'プロフィール',
        SP: 'Mi perfil',
        KOR: '내 프로필',
        CIN: '我的简介',
        POL: 'Mój profil',
        RUS: 'Мой профиль',
        NLD: 'Mijn profiel',
        NOR: 'Min profil',
      }[lang];
    default:
      return {
        GER: 'Profil',
        ENG: 'Profile',
        ITA: 'Profilo',
        FRA: 'Profil',
        HNG: 'Profil',
        JAP: 'プロフィール',
        SP: 'Perfil',
        KOR: '프로필',
        CIN: '简介',
        POL: 'Profil',
        RUS: 'Профиль',
        NLD: 'Profiel',
        NOR: 'Profil',
      }[lang];
  }
};

export const ProfileBasis = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'hcn':
      return {
        GER: 'Person',
        ENG: 'Person',
        ITA: 'Person',
        FRA: 'Person',
        HNG: 'Person',
        JAP: 'Person',
        SP: 'Person',
        KOR: 'Person',
        CIN: 'Person',
        POL: 'Person',
        RUS: 'Person',
        NLD: 'Person',
        NOR: 'Person',
      }[lang];
    default:
      return {
        GER: 'Basis',
        ENG: 'Basis',
        ITA: 'Basis',
        FRA: 'Basis',
        HNG: 'Basis',
        JAP: 'Basis',
        SP: 'Basis',
        KOR: 'Basis',
        CIN: 'Basis',
        POL: 'Basis',
        RUS: 'Basis',
        NLD: 'Basis',
        NOR: 'Basis',
      }[lang];
  }
};

export const InfoContactsName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'aps':
      return {
        GER: 'Technischer Ansprechpartner',
        ENG: 'Technischer Ansprechpartner',
        ITA: 'Technischer Ansprechpartner',
        FRA: 'Technischer Ansprechpartner',
        HNG: 'Technischer Ansprechpartner',
        JAP: '技術担当者',
        SP: 'Persona de contacto técnico',
        KOR: '기술 담당자',
        CIN: '技术联系人',
        POL: 'Techniczna osoba kontaktowa',
        RUS: 'Контактное лицо по техническим вопросам',
        NLD: 'Technisch contactpersoon',
        NOR: 'Teknisk kontaktperson',
      }[lang];
    default:
      return {
        GER: 'Kontakt',
        ENG: 'Contacts',
        ITA: 'Contacts',
        FRA: 'Contacts',
        HNG: 'Contacts',
        JAP: 'お問い合わせ',
        SP: 'Contacto',
        KOR: '문의하기',
        CIN: '联系我们',
        POL: 'Skontaktuj się z nami',
        RUS: 'Свяжитесь с нами',
        NLD: 'Contacten',
        NOR: 'Kontakter',
      }[lang];
  }
};

export const CorpsName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'fib':
    case 'bvsbayern':
      return {
        GER: { multi: 'Vereine', single: 'Vereine' },
        ENG: { multi: 'Clubs', single: 'Clubs' },
        FRA: { multi: 'Vereine', single: 'Vereine' },
        HNG: { multi: 'Vereine', single: 'Vereine' },
        ITA: { multi: 'Vereine', single: 'Vereine' },
        JAP: { multi: 'クラブ', single: 'クラブ' },
        SP: { multi: 'Clubes', single: 'Clubes' },
        KOR: { multi: '클럽', single: '클럽' },
        CIN: { multi: '俱乐部', single: '俱乐部' },
        POL: { multi: 'Kluby', single: 'Kluby' },
        RUS: { multi: 'Клубы', single: 'Клубы' },
        NLD: { multi: 'Clubs', single: 'Clubs' },
        NOR: { multi: 'Klubber', single: 'Klubb' },
      }[lang];
    case 'bvs':
      return {
        GER: { multi: 'Verbände', single: 'Verband' },
        ENG: { multi: 'Associations', single: 'Association' },
        FRA: { multi: 'Association', single: 'Association' },
        HNG: { multi: 'Egyesület', single: 'Egyesület' },
        ITA: { multi: 'Associazione', single: 'Associazione' },
        JAP: { multi: '協会', single: '協会' },
        SP: { multi: 'Asociaciones', single: 'Asociación' },
        KOR: { multi: '연결', single: '협회' },
        CIN: { multi: '协会', single: '协会' },
        POL: { multi: 'Stowarzyszenia', single: 'Stowarzyszenie' },
        RUS: { multi: 'Ассоциации', single: 'Ассоциация' },
        NLD: { multi: 'Verenigingen', single: 'Vereniging' },
        NOR: { multi: 'Foreninger', single: 'Forening' },
      }[lang];
    case 'ambassador':
    case 'kiwanis':
    case 'kiwanis-nl':
      return {
        GER: { multi: 'Clubs', single: 'Club' },
        ENG: { multi: 'Clubs', single: 'Club' },
        FRA: { multi: 'Club', single: 'Club' },
        HNG: { multi: 'Klub', single: 'Klub' },
        ITA: { multi: 'Club', single: 'Club' },
        JAP: { multi: 'クラブ', single: 'クラブ' },
        SP: { multi: 'Clubes', single: 'Club' },
        KOR: { multi: '클럽', single: '클럽' },
        CIN: { multi: '俱乐部', single: '俱乐部' },
        POL: { multi: 'Kluby', single: 'Klub' },
        RUS: { multi: 'Клубы', single: 'Клуб' },
        NLD: { multi: 'Clubs', single: 'Club' },
        NOR: { multi: 'Klubber', single: 'Klubb' },
      }[lang];
    case 'keb':
    case 'meinp3':
    case 'badw':
    case 'antonius':
      return {
        GER: { multi: 'Einrichtungen', single: 'Einrichtung' },
        ENG: { multi: 'Establishments', single: 'Establishment' },
        FRA: { multi: 'Installation', single: 'Installation' },
        HNG: { multi: 'Intézmény', single: 'Intézmény' },
        ITA: { multi: 'Istituzione', single: 'Istituzione' },
        JAP: { multi: '設備', single: '家具' },
        SP: { multi: 'Instalaciones', single: 'Mobiliario' },
        KOR: { multi: '시설', single: '가구' },
        CIN: { multi: '设施', single: '家具' },
        POL: { multi: 'Udogodnienia', single: 'Umeblowanie' },
        RUS: { multi: 'Объекты', single: 'Объект' },
        NLD: { multi: 'Vestigingen', single: 'Vestiging' },
        NOR: { multi: 'Etableringer', single: 'Etablering' },
      }[lang];
    case 'atlasinitiative':
      return {
        GER: { multi: 'Sektionen', single: 'Sektion' },
        ENG: { multi: 'Sections', single: 'Section' },
        FRA: { multi: 'Section', single: 'Section' },
        HNG: { multi: 'Szekció', single: 'Szekció' },
        ITA: { multi: 'Sezione', single: 'Sezione' },
        JAP: { multi: 'セクション', single: 'セクション' },
        SP: { multi: 'Secciones', single: 'Sección' },
        KOR: { multi: '섹션', single: '섹션' },
        CIN: { multi: '章节', single: '部门' },
        POL: { multi: 'Sekcje', single: 'Sekcja' },
        RUS: { multi: 'Секции', single: 'Секция' },
        NLD: { multi: 'Secties', single: 'Sectie' },
        NOR: { multi: 'Sekjoner', single: 'Seksjon' },
      }[lang];
    case 'coburgerconvent':
      return {
        GER: { multi: 'Bünde/VACC', single: 'Bund/VACC' },
        ENG: { multi: 'Bünde/VACC', single: 'Bund/VACC' },
        FRA: { multi: 'Confédération/VACC', single: 'Confédération/VACC' },
        HNG: { multi: 'Szövetség/VACC', single: 'Szövetség/VACC' },
        ITA: { multi: 'Confederazione/VACC', single: 'Confederazione/VACC' },
        JAP: { multi: 'フレット／VACC', single: 'フレット／VACC' },
        SP: { multi: 'Trastes/VACC', single: 'Confederación/VACC' },
        KOR: { multi: '프렛/VACC', single: '연맹/VACC' },
        CIN: { multi: '捆绑/VACC', single: '邦联/瓦加杜古委员会' },
        POL: { multi: 'Fretki/VACC', single: 'Konfederacja/VACC' },
        RUS: { multi: 'Комплекты/VACC', single: 'Комплект/VACC' },
        NLD: { multi: 'Bundels/VACC', single: 'Bundel/VACC' },
        NOR: { multi: 'Bunder / VACC', single: 'Bund / VACC' },
      }[lang];
    case 'asbh':
    case 'bdvb':
    case 'gdl':
    case 'kasconnect':
    case 'limconnect':
    case 'bdyoga':
    case 'uhh':
    case 'cbs':
    case 'epochtimes':
    case 'gga':
    case 'cfa':
    case 'jmg':
    case 'hda-alumni':
    case 'moefa':
    case 'mlu':
    case 'wallpen':
      return {
        GER: { multi: 'Gruppen', single: 'Gruppen' },
        ENG: { multi: 'Groups', single: 'Groups' },
        FRA: { multi: 'Groupes', single: 'Groupes' },
        HNG: { multi: 'Csoportok', single: 'Csoportok' },
        ITA: { multi: 'Gruppi', single: 'Gruppi' },
        JAP: { multi: 'グループ', single: 'グループ' },
        SP: { multi: 'Grupos', single: 'Grupos' },
        KOR: { multi: '그룹', single: '그룹' },
        CIN: { multi: '组别', single: '组别' },
        POL: { multi: 'Grupy', single: 'Grupy' },
        RUS: { multi: 'Группы', single: 'Группы' },
        NLD: { multi: 'Groepen', single: 'Groepen' },
        NOR: { multi: 'Klubber', single: 'Klubber' },
      }[lang];

    case 'landfrauen':
      return {
        GER: { multi: 'Ortsvereine', single: 'Ortsverein' },
        ENG: { multi: 'Local associations', single: 'Local association' },
        FRA: { multi: 'Association locale', single: 'Association locale' },
        HNG: { multi: 'Helyi szövetség', single: 'Helyi szövetség' },
        ITA: { multi: 'Associazione locale', single: 'Associazione locale' },
        JAP: { multi: '地元クラブ', single: '地元協会' },
        SP: { multi: 'Clubes locales', single: 'Asociación local' },
        KOR: { multi: '지역 클럽', single: '지역 협회' },
        CIN: { multi: '当地俱乐部', single: '地方协会' },
        POL: { multi: 'Lokalne kluby', single: 'Lokalne stowarzyszenie' },
        RUS: { multi: 'Местные клубы', single: 'Местный клуб' },
        NLD: { multi: 'Lokale verenigingen', single: 'Lokale vereniging' },
        NOR: { multi: 'Lokale foreninger', single: 'Lokale foreninge' },
      }[lang];
    case 'obotritia':
    case 'saxonia':
    case 'wuerttembergia':
      return {
        GER: { multi: 'Bünde', single: 'Bund' },
        ENG: { multi: 'Bünde', single: 'Bund' },
        FRA: { multi: 'Confédération', single: 'Confédération' },
        HNG: { multi: 'Szövetség', single: 'Szövetség' },
        ITA: { multi: 'Confederazione', single: 'Confederazione' },
        JAP: { multi: 'フレット', single: '規約' },
        SP: { multi: 'Trastes', single: 'Pacto' },
        KOR: { multi: '프렛', single: '언약' },
        CIN: { multi: '音阶', single: '公约' },
        POL: { multi: 'Progi', single: 'Przymierze' },
        RUS: { multi: 'Фретки', single: 'Bund' },
        NLD: { multi: 'Bünde', single: 'Bund' },
        NOR: { multi: 'Bunder', single: 'Bunde' },
      }[lang];
    case 'albertina':
    case 'corpsconnect':
    case 'saxo-borussia':
    case 'thuringia':
    case 'corpsrhenania':
      return {
        GER: { multi: 'Corps', single: 'Corps' },
        ENG: { multi: 'Corps', single: 'Corps' },
        FRA: { multi: 'Corps', single: 'Corps' },
        HNG: { multi: 'Testület', single: 'Testület' },
        ITA: { multi: 'Corpo', single: 'Corpo' },
        JAP: { multi: '軍団', single: '軍団' },
        SP: { multi: 'Cuerpo', single: 'Cuerpo' },
        KOR: { multi: '군단', single: '군단' },
        CIN: { multi: '军团', single: '军团' },
        POL: { multi: 'Korpus', single: 'Korpus' },
        RUS: { multi: 'Корпус', single: 'Корпус' },
        NLD: { multi: 'Korps', single: 'Korps' },
        NOR: { multi: 'Korps', single: 'Korps' },
      }[lang];
    case 'metallverband':
      return {
        GER: { multi: 'Innungen', single: 'Innungen' },
        ENG: { multi: 'Guilds', single: 'Guilds' },
        FRA: { multi: 'Injonctions', single: 'Injonctions' },
        HNG: { multi: 'Céhek', single: 'Céhek' },
        ITA: { multi: 'Gilde', single: 'Gilde' },
        JAP: { multi: 'ギルド', single: 'ギルド' },
        SP: { multi: 'Gremios', single: 'Gremios' },
        KOR: { multi: '길드', single: '길드' },
        CIN: { multi: '行会', single: '行会' },
        POL: { multi: 'Gildie', single: 'Gildie' },
        RUS: { multi: 'Гильдии', single: 'Гильдия' },
        NLD: { multi: 'Gilden', single: 'Gilden' },
        NOR: { multi: 'Gilder', single: 'Gilder' },
      }[lang];
    case 'soroptimist':
    case 'soroptimist-at':
      return {
        GER: { multi: 'Mitgliedschaft', single: 'Mitgliedschaft' },
        ENG: { multi: 'Membership', single: 'Membership' },
        FRA: { multi: 'Adhésion', single: 'Adhésion' },
        HNG: { multi: 'Tagság', single: 'Tagság' },
        ITA: { multi: 'Soci', single: 'Soci' },
        JAP: { multi: 'メンバーシップ', single: 'メンバーシップ' },
        SP: { multi: 'Afiliación', single: 'Afiliación' },
        KOR: { multi: '멤버십', single: '멤버십' },
        CIN: { multi: '会员资格', single: '会员资格' },
        POL: { multi: 'Członkostwo', single: 'Członkostwo' },
        RUS: { multi: 'Членство', single: 'Членство' },
        NLD: { multi: 'Lidmaatschap', single: 'Lidmaatschap' },
        NOR: { multi: 'Medlemskap', single: 'Medlemskap' },
      }[lang];
    case 'lfvbayern':
    case 'vbrk':
    case 'werteunion':
    case 'dphv':
    case 'bsb':
    case 'chorverband-rlp':
    case 'ljv-bw':
    case 'bsm':
    case 'ljv-nrw':
    case 'mpg':
    case 'rhlv':
    case 'dkfz':
    case 'eh-darmstadt':
    case 'teutonia':
    case 'lfv-rhein-lahn':
    case 'kab':
    case 'muettergenesungswerk':
    case 'dve':
    case 'ljn':
    case 'bdp':
      return {
        GER: { multi: 'Gliederungen', single: 'Gliederungen' },
        ENG: { multi: 'Gliederungen', single: 'Gliederungen' },
        FRA: { multi: 'Gliederungen', single: 'Gliederungen' },
        HNG: { multi: 'Gliederungen', single: 'Gliederungen' },
        ITA: { multi: 'Gliederungen', single: 'Gliederungen' },
        JAP: { multi: '構造', single: '構造' },
        SP: { multi: 'Estructuras', single: 'Estructuras' },
        KOR: { multi: '구조', single: '구조' },
        CIN: { multi: '结构', single: '结构' },
        POL: { multi: 'Struktury', single: 'Struktury' },
        RUS: { multi: 'Структуры', single: 'Структура' },
        NLD: { multi: 'Structuren', single: 'Structuren' },
        NOR: { multi: 'Struktureringer', single: 'Struktureringe' },
      }[lang];
    case 'aps':
      return {
        GER: { multi: 'Organisationen & AGs', single: 'Organisationen & AGs' },
        ENG: { multi: 'Organization & AGs', single: 'Organization & AGs' },
        FRA: { multi: 'Organisationen & AGs', single: 'Organisationen & AGs' },
        HNG: { multi: 'Organisationen & AGs', single: 'Organisationen & AGs' },
        ITA: { multi: 'Organisationen & AGs', single: 'Organisationen & AGs' },
        JAP: { multi: '組織とAG', single: '組織とAG' },
        SP: { multi: 'Organizaciones y AG', single: 'Organizaciones y AG' },
        KOR: { multi: '조직 및 AG', single: '조직 및 AG' },
        CIN: { multi: '组织和 AG', single: '组织和 AG' },
        POL: { multi: 'Organizacje i AG', single: 'Organizacje i AG' },
        RUS: { multi: 'Организации и AG', single: 'Организация и AG' },
        NLD: { multi: "Organisatie & AG's", single: "Organisatie & AG's" },
        NOR: { multi: 'Organisasjon', single: 'Organisasjon' },
      }[lang];
    case 'wilkar':
      return {
        GER: { multi: 'Objekte', single: 'Objekte' },
        ENG: { multi: 'Objekte', single: 'Objekte' },
        FRA: { multi: 'Objekte', single: 'Objekte' },
        HNG: { multi: 'Objekte', single: 'Objekte' },
        ITA: { multi: 'Objekte', single: 'Objekte' },
        JAP: { multi: '対象物', single: '対象物' },
        SP: { multi: 'Objetos', single: 'Objetos' },
        KOR: { multi: '개체', single: '개체' },
        CIN: { multi: '对象', single: '对象' },
        POL: { multi: 'Obiekty', single: 'Obiekty' },
        RUS: { multi: 'Объекты', single: 'Объект' },
        NLD: { multi: 'Objecten', single: 'Objecten' },
        NOR: { multi: 'Objekter', single: 'Objekte' },
      }[lang];
    case 'eventus':
      return {
        GER: { multi: 'Projekte', single: 'Projekte' },
        ENG: { multi: 'Projekte', single: 'Projekte' },
        FRA: { multi: 'Projekte', single: 'Projekte' },
        HNG: { multi: 'Projekte', single: 'Projekte' },
        ITA: { multi: 'Projekte', single: 'Projekte' },
        JAP: { multi: 'プロジェクト', single: 'プロジェクト' },
        SP: { multi: 'Proyectos', single: 'Proyectos' },
        KOR: { multi: '프로젝트', single: '프로젝트' },
        CIN: { multi: '项目', single: '项目' },
        POL: { multi: 'Projekty', single: 'Projekty' },
        RUS: { multi: 'Проекты', single: 'Проект' },
        NLD: { multi: 'Projecten', single: 'Projecten' },
        NOR: { multi: 'Prosjekter', single: 'Prosjekte' },
      }[lang];
    case 'unisono':
      return {
        GER: { multi: 'Klangkörper', single: 'Klangkörper' },
        ENG: { multi: 'Klangkörper', single: 'Klangkörper' },
        FRA: { multi: 'Klangkörper', single: 'Klangkörper' },
        HNG: { multi: 'Klangkörper', single: 'Klangkörper' },
        ITA: { multi: 'Klangkörper', single: 'Klangkörper' },
        JAP: { multi: 'サウンドボディ', single: 'サウンドボディ' },
        SP: { multi: 'Cuerpo sano', single: 'Cuerpo sano' },
        KOR: { multi: '사운드 바디', single: '사운드 바디' },
        CIN: { multi: '健全的身体', single: '健全的身体' },
        POL: { multi: 'Ciało dźwiękowe', single: 'Ciało dźwiękowe' },
        RUS: { multi: 'Звучное тело', single: 'Звучное тело' },
        NLD: { multi: 'Gezond lichaam', single: 'Gezond lichaam' },
        NOR: { multi: 'Klangkorps', single: 'Klangkorps' },
      }[lang];
    case 'ihk-lahn-dill':
    case 'ihk-frankfurt':
      return {
        GER: { multi: 'Bereiche', single: 'Bereiche' },
        ENG: { multi: 'Bereiche', single: 'Bereiche' },
        FRA: { multi: 'Bereiche', single: 'Bereiche' },
        HNG: { multi: 'Bereiche', single: 'Bereiche' },
        ITA: { multi: 'Bereiche', single: 'Bereiche' },
        JAP: { multi: '地域', single: '地域' },
        SP: { multi: 'Zonas', single: 'Zonas' },
        KOR: { multi: '영역', single: '영역' },
        CIN: { multi: '地区', single: '地区' },
        POL: { multi: 'Obszary', single: 'Obszary' },
        RUS: { multi: 'Области', single: 'Область' },
        NLD: { multi: 'Gebieden', single: 'Gebieden' },
        NOR: { multi: 'Bereiker', single: 'Bereike' },
      }[lang];
    case 'web':
      return {
        GER: { multi: 'Gruppe', single: 'Gruppe' },
        ENG: { multi: 'Group', single: 'Groups' },
        FRA: { multi: 'Groupe', single: 'Groupes' },
        HNG: { multi: 'Csoport', single: 'Csoportok' },
        ITA: { multi: 'Gruppo', single: 'Gruppi' },
        JAP: { multi: 'グループ', single: 'グループ' },
        SP: { multi: 'Grupo', single: 'Grupo' },
        KOR: { multi: '그룹', single: '그룹' },
        CIN: { multi: '组别', single: '组别' },
        POL: { multi: 'Grupa', single: 'Grupa' },
        RUS: { multi: 'Группа', single: 'Группа' },
        NLD: { multi: 'Groep', single: 'Groep' },
        NOR: { multi: 'Klubber', single: 'Klubb' },
      }[lang];
    case 'dbv':
      return {
        GER: { multi: 'Regionalverbände', single: 'Regionalverbände' },
        ENG: { multi: 'Regional associations', single: 'Regional associations' },
        FRA: { multi: 'Regional associations', single: 'Regional associations' },
        HNG: { multi: 'Regional associations', single: 'Regional associations' },
        ITA: { multi: 'Regional associations', single: 'Regional associations' },
        JAP: { multi: '構造', single: '構造' },
        SP: { multi: 'Estructuras', single: 'Estructuras' },
        KOR: { multi: '구조', single: '구조' },
        CIN: { multi: '结构', single: '结构' },
        POL: { multi: 'Struktury', single: 'Struktury' },
        RUS: { multi: 'Структуры', single: 'Структура' },
        NLD: { multi: 'Regionale verenigingen', single: 'Regionale verenigingen' },
        NOR: { multi: 'Regionale foreninger', single: 'Regionale foreninge' },
      }[lang];
    case 'lgf':
      return {
        GER: { multi: 'Kurse', single: 'Kurse' },
        ENG: { multi: 'Courses', single: 'Courses' },
        FRA: { multi: 'Courses', single: 'Courses' },
        HNG: { multi: 'Courses', single: 'Courses' },
        ITA: { multi: 'Courses', single: 'Courses' },
        JAP: { multi: '構造', single: '構造' },
        SP: { multi: 'Estructuras', single: 'Estructuras' },
        KOR: { multi: '구조', single: '구조' },
        CIN: { multi: '结构', single: '结构' },
        POL: { multi: 'Struktury', single: 'Struktury' },
        RUS: { multi: 'Структуры', single: 'Структура' },
        NLD: { multi: 'Cursussen', single: 'Cursussen' },
        NOR: { multi: 'Kurs', single: 'Kurs' },
      }[lang];
    case 'sherides':
      return {
        GER: { multi: 'Regionalgruppen', single: 'Regionalgruppen' },
        ENG: { multi: 'Regionalgruppen', single: 'Regionalgruppen' },
        FRA: { multi: 'Regionalgruppen', single: 'Regionalgruppen' },
        HNG: { multi: 'Regionalgruppen', single: 'Regionalgruppen' },
        ITA: { multi: 'Regionalgruppen', single: 'Regionalgruppen' },
        JAP: { multi: '地域グループ', single: '地域グループ' },
        SP: { multi: 'Regionalgruppen', single: 'Regionalgruppen' },
        KOR: { multi: 'Regionalgruppen', single: 'Regionalgruppen' },
        CIN: { multi: 'Regionalgruppen', single: 'Regionalgruppen' },
        POL: { multi: 'Regionalgruppen', single: 'Regionalgruppen' },
        RUS: { multi: 'Regionalgruppen', single: 'Regionalgruppen' },
        NLD: { multi: 'Regionale groepen', single: 'Regionale groepen' },
        NOR: { multi: 'Regionalgrupper', single: 'Regionalgruppe' },
      }[lang];
    case 'hmv':
      return {
        GER: { multi: 'Organisationen', single: 'Organisationen' },
        ENG: { multi: 'Organization', single: 'Organization' },
        FRA: { multi: 'Organisationen', single: 'Organisationen' },
        HNG: { multi: 'Organisationen', single: 'Organisationen' },
        ITA: { multi: 'Organisationen', single: 'Organisationen' },
        JAP: { multi: '組織と', single: '組織と' },
        SP: { multi: 'Organizaciones', single: 'Organizaciones' },
        KOR: { multi: '조직 및', single: '조직 및' },
        CIN: { multi: '组织和', single: '组织和' },
        POL: { multi: 'Organizacje', single: 'Organizacje' },
        RUS: { multi: 'Организации', single: 'Организация' },
        NLD: { multi: 'Organisatie', single: 'Organisatie' },
        NOR: { multi: 'Organisasjon', single: 'Organisasjon' },
      }[lang];
    case 'dasrad':
      return {
        GER: { multi: 'Status', single: 'Status' },
        ENG: { multi: 'Status', single: 'Status' },
        FRA: { multi: 'Status', single: 'Status' },
        HNG: { multi: 'Status', single: 'Status' },
        ITA: { multi: 'Status', single: 'Status' },
        JAP: { multi: 'Status', single: 'Status' },
        SP: { multi: 'Status', single: 'Status' },
        KOR: { multi: 'Status', single: 'Status' },
        CIN: { multi: 'Status', single: 'Status' },
        POL: { multi: 'Status', single: 'Status' },
        RUS: { multi: 'Status', single: 'Status' },
        NLD: { multi: 'Status', single: 'Status' },
        NOR: { multi: 'Status', single: 'Status' },
      }[lang];
    case 'begabungslust':
    case 'korponnect':
      return {
        GER: { multi: 'Korporationen', single: 'Korporation' },
        ENG: { multi: 'Korporations', single: 'Korporation' },
        FRA: { multi: 'Korporation', single: 'Korporation' },
        HNG: { multi: 'Korporáció', single: 'Korporáció' },
        ITA: { multi: 'Corporazione', single: 'Corporazione' },
        JAP: { multi: '企業', single: 'コーポレーション' },
        SP: { multi: 'Empresas', single: 'Corporación' },
        KOR: { multi: '기업', single: '법인' },
        CIN: { multi: '公司', single: '公司' },
        POL: { multi: 'Korporacje', single: 'Korporacja' },
        RUS: { multi: 'Корпорации', single: 'Корпорация' },
        NLD: { multi: 'Korporaties', single: 'Korporaties' },
        NOR: { multi: 'Korporasjoner', single: 'Korporasjone' },
      }[lang];
    case 'hcn':
      return {
        GER: { multi: 'Organisations', single: 'Organisation' },
        ENG: { multi: 'Organisations', single: 'Organisation' },
        FRA: { multi: 'Organisations', single: 'Organisation' },
        HNG: { multi: 'Organisations', single: 'Organisation' },
        ITA: { multi: 'Organisations', single: 'Organisation' },
        JAP: { multi: '構造', single: '構造' },
        SP: { multi: 'Organisations', single: 'Organisation' },
        KOR: { multi: '구조', single: '구조' },
        CIN: { multi: '结构', single: '结构' },
        POL: { multi: 'Organisations', single: 'Organisation' },
        RUS: { multi: 'Организации', single: 'Организация' },
        NLD: { multi: 'Organisations', single: 'Organisation' },
        NOR: { multi: 'Organisations', single: 'Organisation' },
      }[lang];
    case 'lfvbayern':
    case 'vbrk':
    case 'werteunion':
    case 'dphv':
    case 'bsb':
    case 'chorverband-rlp':
    case 'reservistenverband':
    case 'ljv-bw':
    case 'bsm':
    case 'ljv-nrw':
    case 'mpg':
    case 'rhlv':
    case 'dkfz':
    case 'eh-darmstadt':
    case 'lfv-rhein-lahn':
    case 'kab':
    case 'muettergenesungswerk':
    case 'dve':
    case 'ljn':
    case 'bdp':
    case 'vbb':
    default:
      return {
        GER: { multi: 'Gliederungen', single: 'Gliederungen' },
        ENG: { multi: 'Gliederungen', single: 'Gliederungen' },
        FRA: { multi: 'Gliederungen', single: 'Gliederungen' },
        HNG: { multi: 'Gliederungen', single: 'Gliederungen' },
        ITA: { multi: 'Gliederungen', single: 'Gliederungen' },
        JAP: { multi: '構造', single: '構造' },
        SP: { multi: 'Estructuras', single: 'Estructuras' },
        KOR: { multi: '구조', single: '구조' },
        CIN: { multi: '结构', single: '结构' },
        POL: { multi: 'Struktury', single: 'Struktury' },
        RUS: { multi: 'Структуры', single: 'Структура' },
        NLD: { multi: 'Structuren', single: 'Structuren' },
        NOR: { multi: 'Gliederungen', single: 'Gliederungen' },
      }[lang];
  }
};

// shoundt be used on registration screen
export const CountryName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'wilkar':
      return {
        GER: 'Herkunftsland',
        ENG: 'Country of origin',
        ITA: 'Paese di origine',
        FRA: 'Pays de provenance',
        HNG: 'Származási ország',
        JAP: '原産国',
        SP: 'País de origen',
        KOR: '원산지 국가',
        CIN: '原籍国',
        POL: 'Kraj pochodzenia',
        RUS: 'Страна происхождения',
        NLD: 'Land van herkomst',
        NOR: 'Opprinnelsesland',
      }[lang];
    default:
      return {
        GER: 'Land',
        ENG: 'Country',
        ITA: 'Nazione',
        FRA: 'Pays',
        HNG: 'Ország',
        JAP: '国名',
        SP: 'País',
        KOR: '국가',
        CIN: '国家',
        POL: 'Kraj',
        RUS: 'Страна',
        NLD: 'land',
        NOR: 'Land',
      }[lang];
  }
};

export const SucheCompanyName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'hcn':
      return {
        GER: 'Organisation',
        ENG: 'Organisation',
        ITA: 'Organisation',
        FRA: 'Organisation',
        HNG: 'Organisation',
        JAP: 'Organisation',
        SP: 'Organisation',
        KOR: 'Organisation',
        CIN: 'Organisation',
        POL: 'Organisation',
        RUS: 'Organisation',
        NLD: 'Organisation',
        NOR: 'Organisation',
      }[lang];
    case 'bdf':
      return {
        GER: 'Arbeitgeber',
        ENG: 'Arbeitgeber',
        ITA: 'Arbeitgeber',
        FRA: 'Arbeitgeber',
        HNG: 'Arbeitgeber',
        JAP: 'Arbeitgeber',
        SP: 'Arbeitgeber',
        KOR: 'Arbeitgeber',
        CIN: 'Arbeitgeber',
        POL: 'Arbeitgeber',
        RUS: 'Arbeitgeber',
        NLD: 'Arbeitgeber',
        NOR: 'Arbeitgeber',
      }[lang];
    case 'gew':
      return {
        GER: 'Dienststelle',
        ENG: 'Dienststelle',
        ITA: 'Dienststelle',
        FRA: 'Dienststelle',
        HNG: 'Dienststelle',
        JAP: 'Dienststelle',
        SP: 'Dienststelle',
        KOR: 'Dienststelle',
        CIN: 'Dienststelle',
        POL: 'Dienststelle',
        RUS: 'Dienststelle',
        NLD: 'Dienststelle',
        NOR: 'Dienststelle',
      }[lang];
    default:
      return {
        GER: 'Firma',
        ENG: 'Firma',
        ITA: 'Firma',
        FRA: 'Firma',
        HNG: 'Firma',
        JAP: 'Firma',
        SP: 'Firma',
        KOR: 'Firma',
        CIN: 'Firma',
        POL: 'Firma',
        RUS: 'Firma',
        NLD: 'Firma',
        NOR: 'Firma',
      }[lang];
  }
};

export const ViewCompanyName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'bdf':
      return {
        GER: 'Arbeitgeber',
        ENG: 'Arbeitgeber',
        ITA: 'Arbeitgeber',
        FRA: 'Arbeitgeber',
        HNG: 'Arbeitgeber',
        JAP: 'Arbeitgeber',
        SP: 'Arbeitgeber',
        KOR: 'Arbeitgeber',
        CIN: 'Arbeitgeber',
        POL: 'Arbeitgeber',
        RUS: 'Arbeitgeber',
        NLD: 'Arbeitgeber',
        NOR: 'Arbeitgeber',
      }[lang];
    default:
      return {
        GER: 'Firma',
        ENG: 'Firma',
        ITA: 'Firma',
        FRA: 'Firma',
        HNG: 'Firma',
        JAP: 'Firma',
        SP: 'Firma',
        KOR: 'Firma',
        CIN: 'Firma',
        POL: 'Firma',
        RUS: 'Firma',
        NLD: 'Firma',
        NOR: 'Firma',
      }[lang];
  }
};

export const CompanyName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'hcn':
      return {
        GER: 'Organisation',
        ENG: 'Organisation',
        ITA: 'Organisation',
        FRA: 'Organisation',
        HNG: 'Organisation',
        JAP: 'Organisation',
        SP: 'Organisation',
        KOR: 'Organisation',
        CIN: 'Organisation',
        POL: 'Organisation',
        RUS: 'Organisation',
        NLD: 'Organisation',
        NOR: 'Organisation',
      }[lang];
    case 'bdf':
      return {
        GER: 'Arbeitgeber',
        ENG: 'Arbeitgeber',
        ITA: 'Arbeitgeber',
        FRA: 'Arbeitgeber',
        HNG: 'Arbeitgeber',
        JAP: 'Arbeitgeber',
        SP: 'Arbeitgeber',
        KOR: 'Arbeitgeber',
        CIN: 'Arbeitgeber',
        POL: 'Arbeitgeber',
        RUS: 'Arbeitgeber',
        NLD: 'Arbeitgeber',
        NOR: 'Arbeitgeber',
      }[lang];
    case 'gew':
      return {
        GER: 'Dienststelle',
        ENG: 'Dienststelle',
        ITA: 'Dienststelle',
        FRA: 'Dienststelle',
        HNG: 'Dienststelle',
        JAP: 'Dienststelle',
        SP: 'Dienststelle',
        KOR: 'Dienststelle',
        CIN: 'Dienststelle',
        POL: 'Dienststelle',
        RUS: 'Dienststelle',
        NLD: 'Dienststelle',
        NOR: 'Dienststelle',
      }[lang];
    case 'dphv':
      return {
        GER: 'Schule',
        ENG: 'School',
        ITA: 'Scuola',
        FRA: 'École',
        HNG: 'Iskola',
        JAP: '学校',
        SP: 'Escuela',
        KOR: '학교',
        CIN: '学校',
        POL: 'Szkoła',
        RUS: 'Школа',
        NLD: 'School',
        NOR: 'Skole',
      }[lang];
    default:
      return {
        GER: 'Unternehmen',
        ENG: 'Company',
        ITA: 'Aziende',
        FRA: 'Société',
        HNG: 'Cég',
        JAP: '同社',
        SP: 'La empresa',
        KOR: '회사',
        CIN: '该公司',
        POL: 'Firma',
        RUS: 'Компания',
        NLD: 'Bedrijf',
        NOR: 'Selskap',
      }[lang];
  }
};

export const IndustryName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'dphv':
      return {
        GER: 'Schulform',
        ENG: 'Type of school',
        ITA: 'Tipo di scuola',
        FRA: "Type d'école",
        HNG: 'Az iskola típusa',
        SP: 'Tipo de escuela',
        KOR: '학교 유형',
        JAP: '学校の種類',
        CIN: '学校类型',
        POL: 'Typ szkoły',
        RUS: 'Тип школы',
        NLD: 'Type school',
        NOR: 'Skoletype',
      }[lang];
    default:
      return {
        GER: 'Branche',
        ENG: 'Industry',
        ITA: 'Ramo',
        FRA: 'Industrie',
        HNG: 'Ipar',
        SP: 'Industria',
        KOR: '산업',
        JAP: '産業',
        CIN: '行业',
        POL: 'Przemysł',
        RUS: 'Отрасль',
        NLD: 'Industrie',
        NOR: 'Industri',
      }[lang];
  }
};

export const ActivityName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'dphv':
      return {
        GER: 'Fächer',
        ENG: 'Subjects',
        ITA: 'Soggetti',
        FRA: 'Éventail',
        HNG: 'Tantárgyak',
        SP: 'Temas',
        KOR: '주제',
        JAP: '対象',
        CIN: '主题',
        POL: 'Przedmioty',
        RUS: 'Предметы',
        NLD: 'Onderwerpen',
        NOR: 'Fag',
      }[lang];
    default:
      return {
        GER: 'Ihr Tätigkeitsfeld',
        ENG: 'Field of activity',
        ITA: 'Il tuo campo di attività',
        FRA: "Votre domaine d'activité",
        HNG: 'Tevékenységi Szakterület',
        SP: 'Ámbito de actividad',
        KOR: '활동 분야',
        JAP: '活動分野',
        CIN: '活动领域',
        POL: 'Obszar działalności',
        RUS: 'Область деятельности',
        NLD: 'Activiteitsgebied',
        NOR: 'Aktivitetsområde',
      }[lang];
  }
};

export const SearchName = (lang: langTypes) => {
  switch (config.APP_NAME) {
    case 'begabungslust':
      return {
        GER: 'Suche & Profile',
        ENG: 'Search & Profiles',
        FRA: 'Recherche et profils',
        HNG: 'Keresés és profilok',
        ITA: 'Ricerca e profili',
        JAP: '検索とプロフィール',
        SP: 'Búsqueda y perfiles',
        KOR: '검색 및 프로필',
        CIN: '搜索和个人资料',
        POL: 'Wyszukiwanie i profile',
        RUS: 'Поиск и профили',
        NLD: 'Zoeken en profielen',
        NOR: 'Søk og profiler',
      }[lang];
    default:
      return {
        GER: 'Suche',
        ENG: 'Search',
        FRA: 'Recherchez',
        HNG: 'Keresés',
        ITA: 'Ricerca',
        JAP: '検索',
        SP: 'Buscar en',
        KOR: '검색',
        CIN: '搜索',
        POL: 'Wyszukiwanie',
        RUS: 'Поиск',
        NLD: 'Zoek op',
        NOR: 'Søk',
      }[lang];
  }
};
